import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const getContentBlock = createAsyncThunk(
  'auth/getContentBlock',
  async ({ contentBlockId, languageId }: GetContentBlockType) => {
    const { data } = await axios.get(
      `/content-block/${contentBlockId}/${languageId}`
    );
    return data.data.contentBlock as ContentBlock;
  }
);

interface GetContentBlockType {
  contentBlockId: number;
  languageId: number;
}

type ContentBlock = {
  id: number;
  contentBlockId: number;
  title: string;
  content: string;
  dateCreated: string;
  dateUpdated: string;
};

export interface contentBlockSliceType {
  loading: boolean;
  contentBlock: ContentBlock;
}

const initialState = {
  loading: false,
  contentBlock: {}
} as contentBlockSliceType;

const contentBlockSlice = createSlice({
  name: 'contentBlock',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getContentBlock.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getContentBlock.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.contentBlock = payload;
    });
    builder.addCase(getContentBlock.rejected, (state) => {
      state.loading = false;
    });
  }
});

export default contentBlockSlice.reducer;
